// extracted by mini-css-extract-plugin
module.exports = {"cell":"FormattedMarketplaceLogo_cell__1GnR5","internal":"FormattedMarketplaceLogo_internal__7jo48","notLoggedIn":"FormattedMarketplaceLogo_notLoggedIn__dH8lP"};